module.exports = __webpack_public_path__ + "static/media/non_adhesive_labels.692a181e.jpg";